'use strict';

exports.__esModule = true;
var _ = require('./');
var _2 = _interopRequireDefault(_);
var _framesync = require('framesync');
var _calc = require('../inc/calc');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Physics = function (_Action) {
  _inherits(Physics, _Action);
  function Physics() {
    _classCallCheck(this, Physics);
    return _possibleConstructorReturn(this, _Action.apply(this, arguments));
  }
  Physics.prototype.update = function update() {
    var _props = this.props,
      autoStopSpeed = _props.autoStopSpeed,
      acceleration = _props.acceleration,
      friction = _props.friction,
      velocity = _props.velocity,
      spring = _props.spring,
      to = _props.to;
    var newVelocity = velocity;
    var elapsed = (0, _framesync.timeSinceLastFrame)();

    // Apply acceleration to velocity
    if (acceleration) {
      newVelocity += (0, _calc.speedPerFrame)(acceleration, elapsed);
    }

    // Apply friction to velocity
    if (friction) {
      newVelocity *= Math.pow(1 - friction, elapsed / 100);
    }
    if (spring && to !== undefined) {
      var distanceToTarget = to - this.current;
      newVelocity += distanceToTarget * (0, _calc.speedPerFrame)(spring, elapsed);
    }

    // Apply velocity
    this.current += (0, _calc.speedPerFrame)(newVelocity, elapsed);
    this.props.velocity = newVelocity;

    // Check if simulation is complete
    // We do this here instead of `isActionComplete` as it allows us
    // to clamp during this update
    this.isComplete = autoStopSpeed !== false && (!newVelocity || Math.abs(newVelocity) <= autoStopSpeed);
    if (this.isComplete && spring) {
      this.current = to;
    }
    return this.current;
  };
  Physics.prototype.isActionComplete = function isActionComplete() {
    return this.isComplete;
  };
  return Physics;
}(_2.default);
Physics.defaultProps = {
  acceleration: 0,
  friction: 0,
  velocity: 0,
  autoStopSpeed: 0.001
};
exports.default = function (props) {
  return new Physics(props);
};